import { Component } from 'react';
import { connect } from 'react-redux';

// eslint-disable-next-line import/no-cycle
import ClubMembershipDisplayPersonalizationBlock from './list/ClubMembershipDisplayPersonalizationBlock';

class ClubMembershipList extends Component {
  componentDidMount() {}

  render() {
    const { settings, clubMemberships } = this.props;
    if (
      !settings.data ||
      !clubMemberships.data ||
      clubMemberships.query === null
    ) {
      return null;
    }

    return (
      <>
        <div className="c7-account__clubs">
          {clubMemberships.query.map((clubMembershipId) => {
            const clubMembership = clubMemberships.data[clubMembershipId];
            return (
              <ClubMembershipDisplayPersonalizationBlock
                key={clubMembership.id}
                clubMembership={clubMembership}
              />
            );
          })}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  clubMemberships: state.clubMembership,
  settings: state.setting
});

export default connect(mapStateToProps)(ClubMembershipList);
